// Codekit -->
// @codekit-prepend "global/vars.js"
// @codekit-prepend "utilities/debounce.js"
// @codekit-prepend "utilities/ajax.js"
// @codekit-prepend "utilities/lazy.js"
// @codekit-prepend "utilities/loadIn.js"
// @codekit-prepend "utilities/image-viewer.js"
// @codekit-prepend "utilities/rhparallax.js"
// @codekit-prepend "utilities/full-height.js"


// @codekit-prepend "components/header.js"
// @codekit-prepend "components/menu.js"
// @codekit-prepend "components/panorama.js"
// @codekit-prepend "components/flickity.js"
// @codekit-prepend "components/scroll-button.js"
// @codekit-prepend "components/projects-filter.js"
// @codekit-prepend "components/logo-flick.js"
// @codekit-prepend "components/video-embed.js"
// @codekit-prepend "components/loader.js"
// @codekit-prepend "components/icon-follow-mouse.js"

// @codekit-prepend "components/cursor.js"


// @codekit-append "global/document-ready.js"
// @codekit-append "global/resize.js"

//<- Codekit

//Funcitons start -->
//cusror
// cursor();

//Menu
menu();

//Header
window.addEventListener("scroll", debounce(headerScroll));

//loader
if (typeof loader != "undefined" && loader != null) {
    runLoader();
}

if (typeof projectFilter != "undefined" && projectFilter != null) { 
    projectFilterProcess();
}

//scrolls

if (typeof scrollButtons != "undefined" && scrollButtons != null) {
    scrollDownFullHeight()
}

if (typeof articleScrollButton != "undefined" && articleScrollButton != null) {
    scrollToTarget(articleScrollButton, articleContent);
}

if (typeof expertiseScrollButton != "undefined" && expertiseScrollButton != null) {
    scrollToTarget(expertiseScrollButton, expertiseScrollSection);
}

if (typeof vacanciesScrollButton != "undefined" && vacanciesScrollButton != null) {
    scrollToTarget(vacanciesScrollButton, vacanciesScrollSection);
}

if (typeof teamScrollButton != "undefined" && teamScrollButton != null) {
    scrollToTarget(teamScrollButton, teamScrollSection);
}

if (typeof socialScrollButton != "undefined" && socialScrollButton != null) {
    scrollToTarget(socialScrollButton, socialScrollSection);
}

if (typeof heroes != "undefined" && heroes != null) {
    makeFullHeight(heroes);
}

if (typeof articleScrollButtonWrapper != "undefined" && articleScrollButtonWrapper != null) {
    makeFullHeight(articleScrollButtonWrapper);
}

if (typeof practiceSubHeader != "undefined" && practiceSubHeader != null) {
    makeSubHeaderSticky();
}

if (typeof heroScrollDown != "undefined" && heroScrollDown != null) {
    scrollDownFullHeight();
}

if (typeof iconGroup != "undefined" && iconGroup != null  && iconGroup.length > 0) {
    iconFlick();
}



//<-- Funcitons end




//Being rolled into lazyload by Guy
//This pauses videos on page refresh
//Ensures no flash of white
$(window).on("beforeunload", function () {
    //console.log('PAUSE VIDEO');
    $(".vidUnload").each(function () {
        $(this).get(0).pause();
    });
});